export default Object.freeze({
    LOGO: 'logo',
    ICON: 'icon',
    DOCUMENT: 'document',
    BANNER: 'banner',
    PHOTO: 'photo'
  });